import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/home.scss";
import { backend } from '../../../components/apipath';

function Newsarea() {
    const [newsData, setNewsData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [categories, setCategories] = useState([]);
    const [currentImageId, setCurrentImageId] = useState(0);
    const cardsPerPage = 10;

    useEffect(() => {
        fetchCategories(); // 初始拉取類別資料
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${backend}home/newsCategories`);
            setCategories(response.data); // 設定類別資料
            if (response.data.length > 0) {
                newsButtonClick(response.data[0].art_type); // 預設載入第一個類別的新聞
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const newsButtonClick = async (categoryId) => {
        try {
            const response = await axios.get(`${backend}home/newsselect/${categoryId}`);
            setNewsData(response.data);
            setCurrentPage(1);
            setCurrentImageId(categoryId);
        } catch (error) {
            console.error("Error fetching news:", error);
        }
    };


    const getPageNumbersToShow = () => {
        const maxPageNumbersToShow = 10;
        const totalCards = Object.values(newsData).flat().length;
        const totalPages = Math.ceil(totalCards / cardsPerPage);
        const middlePage = currentPage;
        const halfMaxPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

        let startPage = middlePage - halfMaxPageNumbersToShow;
        let endPage = middlePage + halfMaxPageNumbersToShow;

        if (startPage <= 0) {
            startPage = 1;
            endPage = Math.min(totalPages, maxPageNumbersToShow);
        }

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - maxPageNumbersToShow + 1);
        }

        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    };

    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentNews = Object.values(newsData).flat().slice(startIndex, endIndex);

    
    return (
        <div className="container">
            <div className="row">
                <div className="newtitle">News</div>
                <div className="nav nav-tabs newtab">
                    {categories.map((category) => (
                        <li className="nav-item" role="presentation" key={category.art_type}>
                            <button
                                className="nav-link"
                                type="button"
                                role="tab"
                                aria-controls="news"
                                aria-selected="false"
                                onClick={() => newsButtonClick(category.art_type)}
                            >
                                {category.name}
                            </button>
                        </li>
                    ))}
                </div>
                <div className="tabcontent row">
                    <div className="col-4 w-25 newc">
                        <img
                                src={
                                    currentImageId
                                        ? `/homeImg/news${currentImageId}.png`
                                        : "/homeImg/news1.png"
                                }
                                alt="News"
                                loading="lazy"
                        />
                    </div>
                    <div className="news col-8" id="myTabContent">
                        {currentNews.map((item, index) => (
                            <ul className="tab-pane list-group list-group-flush" key={`${index}-${item.art_id}`}>
                                <Link to={`/home/newdetail/${item.new_id}`}>
                                    <li className="list-group-item">{item.title}</li>
                                </Link>
                            </ul>
                        ))}
                    </div>
                    
                </div>
                <div className="pagination mb100">
                    {getPageNumbersToShow().map((number) => (
                        <button
                            className="page-link"
                            key={number}
                            onClick={() => setCurrentPage(number)}
                        >
                            {number}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Newsarea;